const API_PLACEHOLDER = "__VIDQUIZ_API__";

/**
 * Load the transcript bookmarklet source and substitute this deployment's API
 * origin. The asset lives in `public/` and is deployment-agnostic until now.
 */
export async function loadBookmarkletCode(apiOrigin: string): Promise<string> {
  const res = await fetch("/fetch-transcript.js", { headers: { Accept: "text/javascript" } });
  if (!res.ok) {
    throw new Error("Could not load the transcript helper.");
  }
  const source = await res.text();
  return source.split(API_PLACEHOLDER).join(apiOrigin.replace(/\/+$/, ""));
}

/** Turn the bookmarklet source into a draggable `javascript:` href. */
export function toBookmarkletHref(code: string): string {
  return `javascript:${encodeURIComponent(code)}`;
}

/** Origin used by the bookmarklet to reach this deployment's API. */
export function currentApiOrigin(): string {
  return window.location.origin;
}
